//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { map , filter , uniqBy , cloneDeep } from "lodash"

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const activitiesInitial = [];
const activityInitial = {};

export const activity = (state = activityInitial, action) => {
    switch (action.type) {
        case ActionTypes.activities.getActivitySuccess:
            return action.payload;
        case ActionTypes.activities.getActivityFail:
            return state;
        default:
            return state;
    }
};

export const activities = (state = activitiesInitial, action) => {
    switch (action.type) {
        case ActionTypes.activities.createActivitySuccess:
            return uniqBy([action.payload, ...state],"id");
        case ActionTypes.activities.updateActivitesSuccess:
            const v = cloneDeep(state)
            return v.map(k => {
                if (k.id === action.payload.id) {
                    return { ...k, ...action.payload }
                }
                return k;
            })
        case ActionTypes.activities.deleteActivitesSuccess:
            const delv = cloneDeep(state)
            return filter(delv,k =>k.id != action.payload.id)
        case ActionTypes.activities.listActivitiesSuccess:
        case ActionTypes.activities.listChapterActivitiesSuccess:   
            const existingIdsForListActivities = new Set(action.payload.map(item => item?.id).filter(Boolean));
            const filteredStateForListActivities = state.filter(item => !existingIdsForListActivities.has(item.id));
            return [...filteredStateForListActivities, ...action.payload];
        case ActionTypes.activities.createActivityFail:
        case ActionTypes.activities.listActivitiesFail:
        case ActionTypes.activities.listChapterActivitiesFail:
            return state;
        case ActionTypes.assignmenent.listAssignmentByUserSuccess:
            const existingIdsForAssignments = new Set(action.payload.map(item => item.id));
            const filteredStateForAssignments = state.filter(item => !existingIdsForAssignments.has(item.id));
            return [...filteredStateForAssignments, ...action.payload];
        case ActionTypes.assignmenent.createCustomAssignmentSuccess:
            return [action.payload, ...state];
        case ActionTypes.assignmenent.updateCustomAssignmentSuccess:
            return map(state,st=>st.id===action.payload.id?action.payload:st)
        case ActionTypes.assignmenent.deleteCustomAssignmentSuccess:
            return filter(state,st=>st.id!==action.payload)
        case ActionTypes.activities.listActivitiesByIdsSuccess:
            const existingIdsForActivities = new Set(action.payload.map(item => item.id));
            const filteredStateForActivities = state.filter(item => !existingIdsForActivities.has(item.id));
            return [...filteredStateForActivities, ...action.payload];
        case ActionTypes.activities.deleteEnageActivitySuccess:
            const clonedState = cloneDeep(state)
            return filter(clonedState,k => !action.payload?.includes(k.id))
        default:
            return state;
    }
};

const ownGraphicOrganizerInitial = [];

export const ownGraphicOrganizers = (state = ownGraphicOrganizerInitial, action) => {
    switch (action.type) {
        case ActionTypes.ownGraphicOrganizer.createOwnGraphicOrganizerSuccess:
            return uniqBy([action.payload, ...state], "id");
        case ActionTypes.ownGraphicOrganizer.updateOwnGraphicOrganizerSuccess:
            return map(state, item => item.id === action.payload.id ? action.payload : item);
        case ActionTypes.ownGraphicOrganizer.listOwnGraphicOrganizerSuccess:
            return action.payload;
        case ActionTypes.ownGraphicOrganizer.deleteOwnGraphicOrganizerSuccess:
            return filter(state, item => item.id !== action.payload);
        case ActionTypes.ownGraphicOrganizer.createOwnGraphicOrganizerFail:
        case ActionTypes.ownGraphicOrganizer.updateOwnGraphicOrganizerFail:
        case ActionTypes.ownGraphicOrganizer.listOwnGraphicOrganizerFail:
        case ActionTypes.ownGraphicOrganizer.deleteOwnGraphicOrganizerFail:
            return state;
        default:
            return state;
    }
};

const shareListInitial = [];

export const shareList = (state = shareListInitial, action) => {
    switch (action.type) {
        case ActionTypes.activities.listShareListSuccess:
            return Array.isArray(action.payload) ? action.payload : [];
        default:
            return state;
    }
};